import React from 'react'
import clsx from 'clsx'
import { MVP_LANDING_PATH } from '../constants/mvpSeo'

export const CheckIcon = ({ className = 'text-primary_green' }) => (
  <svg
    className={clsx('flex-none', className)}
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
  >
    <path d="M20 6L9 17l-5-5" />
  </svg>
)

export const CrossIcon = () => (
  <svg
    className="flex-none text-[#c23a3a] mt-0.5"
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
  >
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
)

export function encodeFormData(data) {
  const formData = new FormData()
  for (const key of Object.keys(data)) {
    formData.append(key, data[key])
  }
  return formData
}

export const MVP_CALENDLY_URL =
  'https://calendly.com/contact-anglebrackets/30min'

function getStickyHeaderOffset() {
  if (typeof window === 'undefined') return 0

  const nav = document.querySelector('[data-testid="sanity-navbar"]')
  const navHeight = nav ? nav.getBoundingClientRect().height : 0

  // Small breathing room under the sticky bar (mobile Safari needs a bit more)
  const isMobile = window.matchMedia('(max-width: 1023px)').matches
  return Math.ceil(navHeight + (isMobile ? 12 : 8))
}

function scrollEstimateIntoPlace() {
  const target = document.getElementById('estimate')
  if (!target) return false

  const offset = getStickyHeaderOffset()
  const top =
    target.getBoundingClientRect().top + window.scrollY - offset

  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
  return true
}

export const MVP_ESTIMATE_BUDGET_PREFILL_EVENT = 'mvp-estimate-budget-prefill'

/** One-shot budget for estimate form (not persisted). */
export function prefillEstimateBudget(budget) {
  if (typeof window === 'undefined' || !budget) return
  window.dispatchEvent(
    new CustomEvent(MVP_ESTIMATE_BUDGET_PREFILL_EVENT, {
      detail: { budget },
    })
  )
}

const normalizePathname = (pathname = '') => {
  const path = String(pathname).split('?')[0].split('#')[0]
  if (!path || path === '/') return '/'
  return path.replace(/\/+$/, '') || path
}

/** True on /ai-mvp-development/ (and legacy /mvp-development/ alias). */
export const isMvpLandingPath = (pathname = '') => {
  const normalized = normalizePathname(pathname)
  const mvpPath = normalizePathname(MVP_LANDING_PATH)
  return normalized === mvpPath || normalized === '/mvp-development'
}

/** Smooth-scroll to the MVP estimate form (#estimate). Optional `budget` pre-selects range. */
export function scrollToEstimate(event, options = {}) {
  if (event?.preventDefault) event.preventDefault()
  if (typeof window === 'undefined') return

  const { budget } = options
  if (budget) prefillEstimateBudget(budget)

  const target = document.getElementById('estimate')
  if (!target) return

  if (window.location.hash !== '#estimate') {
    window.history.pushState(null, '', '#estimate')
  }

  scrollEstimateIntoPlace()

  // Mobile: layout can settle after first paint / sticky header; nudge once.
  window.setTimeout(() => {
    if (window.location.hash !== '#estimate') return
    const el = document.getElementById('estimate')
    if (!el) return

    const offset = getStickyHeaderOffset()
    const delta = el.getBoundingClientRect().top - offset
    if (Math.abs(delta) > 24) {
      window.scrollTo({
        top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - offset),
        behavior: 'smooth',
      })
    }
  }, 400)
}
